/** Styl tlačítka k tématu Erma */
export const ButtonStyles = {
  background: 'var(--erma-primary-700)',
  border: 'none',
  color: 'var(--erma-primary-0)',
  hoverBackground: 'var(--erma-primary-600)',
  hoverBorder: 'none',
  hoverColor: 'var(--erma-primary-0)',
  focusOutline: '2px solid var(--erma-primary-900)',
  paddingY: '0.1em',
  paddingX: '0.4em',
  borderRadius: '6px',
  gap: '.2rem',
  primary: {
    background: 'var(--erma-primary-700)',
    border: 'none',
    color: 'var(--erma-primary-0)',
    focusOutline: '2px solid var(--erma-primary-900)',
    hover: {
      background: 'var(--erma-primary-600)',
      border: 'none',
      color: 'var(--erma-primary-0)',
    }
  },
  secondary: {
    background: "var(--erma-secondary-100)",
    hoverBackground: "var(--erma-secondary-200)",
    activeBackground: "var(--erma-secondary-300)",
    borderColor: "var(--erma-secondary-100)",
    hoverBorderColor: "var(--erma-secondary-200)",
    activeBorderColor: "var(--erma-secondary-300)",
    color: "var(--erma-secondary-600)",
    hoverColor: "var(--erma-secondary-700)",
    activeColor: "var(--erma-secondary-800)",
    focusRing: {
      color: "var(--erma-secondary-600)",
      shadow: "none"
    }
  },
  iconOnlyWidth: '2.357em',
  textSecondaryColor: 'var(--erma-secondary-480)',
  danger: {
    background: '#EF4444',
    color: 'var(--erma-secondary-0)',
    hover: {
      background: '#DC2626',
      color: 'var(--erma-secondary-0)',
    }
  },
  extend: {
    marginLeft: '.3rem',
    marginRight: '.3rem'
  },
  css: ({ dt }) => `
        .p-button{
          margin-left: ${dt('button.marginLeft')};
          margin-right: ${dt('button.marginRight')};
        }
        `
};
